const { createSelector } = require('reselect');
const { selectSliceCisview } = require('./HELPERS');

export const selectMaps = createSelector(
	selectSliceCisview,
	({ maps }) => maps
);

export const selectCommentPatternToExclude = createSelector(
	selectMaps,
	({ commentPatternToExclude }) => commentPatternToExclude
);
